require('./cardLegalViewerModal.scss');

const PropTypes = require('prop-types');
const React = require('react');
const { Component } = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { EmptyState } = require('commonsComponents/emptyState');
import { OKLink } from 'commonsComponents/OKLink';

// @ constant
const {
    PDF_LETTER_NORMAL_HEIGHT,
    PDF_LETTER_MODAL_SCALE,
    PDF_LETTER_NORMAL_SCALE
} = require('constants/revolvingCardsProcess');
const { EMPTY_STATE_NOCARD_BANKING } = require('constants/index');
const { DIAMOND_PACK_PRODUCT_NAME, PREMIUM_PACK_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');

//@actions
const revolvingActions = require('actions/cardRevolvingDocuments');

//@helpers
const { validRevolvingCardType } = require('utilities/APIParsingHelper');

class CardLegalViewerModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            viewerHeightModal: 'auto',
            scrollFinalDone: false,
            agreeCheckboxInne: false,
            primaryButtonText: formatText(this.getPoeKey('inneDocumentModalBtnPrimary'))
        }
    }

    componentDidMount() {
        const { requestRevolvingDocument, resetRevolvingProcess, precontractualMailProductInfo, showRevolvingDocument, amount } = this.props;
        const fakeCheckboxEvent = {
            target: {
                checked: false
            }
        }
        resetRevolvingProcess();
        this.handleSetAgreeRevol(fakeCheckboxEvent);
        requestRevolvingDocument('inne', precontractualMailProductInfo, showRevolvingDocument, amount);
        this.validateTermsAndCondsText();
    }

    componentWillUnmount() {
        const { resetRevolvingProcess } = this.props;
        resetRevolvingProcess();
    }

    validateTermsAndCondsText = () => {
        const { setTermsAndCondsText, showRevolvingDocument } = this.props;
        let textTermsAndConds = {
            inne: this.getPoeKey('inneCheckboxText')
        };

        if (showRevolvingDocument) {
            textTermsAndConds['revolving'] = this.getPoeKey('documentCheckboxText');
        }

        setTermsAndCondsText(textTermsAndConds);
    }

    checkRelevantDocument = () => {
        const { showRevolvingDocument, immFeatureFlags, precontractualMailProductInfo } = this.props;

        this.setState({
            primaryButtonText: formatText(this.getPoeKey('inneDocumentReadedModalBtnPrimary'))
        });
        const isRevolvingDocumentVisible = immFeatureFlags.get('revolving_v2_ine') && validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
            ? !validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
            : showRevolvingDocument;

        if (isRevolvingDocumentVisible) {
            const { precontractualMailProductInfo, requestRevolvingDocument } = this.props;
            requestRevolvingDocument('document', precontractualMailProductInfo);
        } else {

            const fakeCheckboxEvent = {
                target: {
                    checked: true
                }
            }
            this.handleSetAgreeRevol(fakeCheckboxEvent);
        }
    }

    handleDocumentReaded = (isModal) => {
        if (isModal) {
            this.setState({
                scrollFinalDone: true
            });
        }
    }

    handlePdfDownload = (type) => {
        const { downloadRevolvingPDF } = this.props;
        const fileName = formatText(this.getPoeKey(`${type}PdfName`))
        downloadRevolvingPDF(type, fileName);
    }

    handleOnShowModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal
        }));
    }

    handleSetAgreeInne = () => {
        this.setState((prevState) => ({
            agreeCheckboxInne: !prevState.agreeCheckboxInne
        }));
    }

    handleSetAgreeRevol = (event) => {
        const { handleAgreementCheckboxChange } = this.props;
        handleAgreementCheckboxChange(event);
    }

    handleIneLink = () => {
        const { agreeCheckboxInne } = this.state;
        if (agreeCheckboxInne) {
            this.handleOnShowModal();
        }
    }

    handleContinue = () => {
        const { immPdfRevolving, immPdfRevolvingPersistent, isContractingProcess, immFeatureFlags } = this.props;
        const documentReaded = immPdfRevolving.get('documentReaded');
        const temporaryDocumentId = immPdfRevolvingPersistent.get('temporaryDocumentId');
        const revolvingDocumentFeatureFlag = immFeatureFlags.get('revolving_v2_ine');

        if (!documentReaded) {
            const {
                precontractualMailProductInfo,
                sendPrecontractualDocumentMail,
                setDocumentInneReaded,
                showRevolvingDocument
            } = this.props;
            const params = {
                product: {
                    standard: precontractualMailProductInfo.standard,
                    subtype: precontractualMailProductInfo.subproducto,
                    type: precontractualMailProductInfo.producto
                },
                contactCenter: false,
                sendInsuranceDocument: isContractingProcess,
                sendRelevantRevolvingDocument: revolvingDocumentFeatureFlag && validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
                    ? !revolvingDocumentFeatureFlag
                    : showRevolvingDocument,
                temporaryDocumentId
            };

            setDocumentInneReaded(true);
            sendPrecontractualDocumentMail(params);
            this.checkRelevantDocument();
        }

        this.handleOnShowModal();
    }

    getSize = (height) => {
        this.setState({ viewerHeightModal: height - 64 });
    }

    getPoeKey = (key) => {
        return `revolvingProcessDocuments-revolvingProcessDocuments_${key}`;
    }

    buildViewer = (isModal, type) => {
        const {
            immPdfRevolving,
            onPrintRevolvingDocument
        } = this.props;
        const { viewerHeightModal } = this.state;
        const pdfFile = immPdfRevolving.getIn([`${type}PDF`, 'base64string']);
        const isFetching = immPdfRevolving.get(`${type}IsFetching`);
        const errorContent = immPdfRevolving.get(`${type}Error`);
        const title = formatText(this.getPoeKey(`${type}PDFContainerTitle`));
        const viewerHeight = isModal ? viewerHeightModal : PDF_LETTER_NORMAL_HEIGHT;
        const scalePdf = isModal ? PDF_LETTER_MODAL_SCALE : PDF_LETTER_NORMAL_SCALE;
        const classNamePdfContainer = classNames({
            'revolving-pdf-viewer--modal': isModal,
            'revolving-document__revolving-pdf': !isModal
        });
        let pdfComponent;
        if (pdfFile) {
            pdfComponent = (
                <div className={classNamePdfContainer}>
                    <OKPdfViewer
                        displayInlinePages={!isModal}
                        isDebounceable={false}
                        onDownload={() => this.handlePdfDownload(type)}
                        onPrint={() => onPrintRevolvingDocument(type)}
                        pdfFile={pdfFile}
                        viewerHeight={viewerHeight}
                        showPageShadow={!isModal}
                        onDocumentReaded={() => this.handleDocumentReaded(isModal)}
                        scale={scalePdf}
                        title={title}
                        hasBorder={true}
                        showScroll
                    />
                </div>
            )
        } else if (isFetching) {
            pdfComponent = (
                <LoadingSection />
            )
        } else if (errorContent) {
            pdfComponent = this.buildErrorComponent(title, type);
        }

        return pdfComponent;
    }

    buildErrorComponent = (title, type) => {
        const { requestRevolvingDocument, precontractualMailProductInfo, showRevolvingDocument, amount } = this.props;
        const retryButton = (
            <OKButton
                modifier="secondary"
                onClick={() => { requestRevolvingDocument(type, precontractualMailProductInfo, showRevolvingDocument, amount); }}>
                <FormattedText value={this.getPoeKey('retryButton')} />
            </OKButton>
        );

        return (
            <div>
                <div className="revolving-error__header">
                    {title}
                </div>
                <EmptyState
                    button={retryButton}
                    primaryText={formatText(this.getPoeKey('errorMessage'))}
                    iconType={EMPTY_STATE_NOCARD_BANKING}
                    withMargin={true}
                />
                <div className="revolving-error__content-err">
                    <FormattedText value={this.getPoeKey('pdfErrorMessage')} />
                </div>
            </div>
        );
    }

    buildModalContentFooter = () => {
        let modalContentFooter = (<div className="revolving-modal__check-section"></div>);
        const { immPdfRevolving } = this.props
        const { scrollFinalDone, agreeCheckboxInne } = this.state;
        const documentReaded = immPdfRevolving.get('documentReaded');
        const label = (
            <FormattedText
                value={this.getPoeKey('inneCheckboxText')}
                className="revolving-modal__terms-and-conditions"
            />
        );
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const className = classNames('revolving-modal__checkbox-modal');

        if (scrollFinalDone || agreeCheckboxInne) {
            modalContentFooter = (
                <OKCheckbox
                    disabled={agreeCheckboxInne && documentReaded}
                    errorMessage={errorMessage}
                    idName="revolving-modal-checkbox"
                    labelId="revolving-modal-checkbox-label"
                    label={label}
                    onChange={this.handleSetAgreeInne}
                    value={agreeCheckboxInne}
                />
            );
        }

        return (
            <div className={className}>
                {modalContentFooter}
            </div>
        );
    }

    buildRevolvingDocument = () => {
        const { agreeCheckboxRevol, immPdfRevolving, precontractualMailProductInfo } = this.props;
        const pdfFile = immPdfRevolving.getIn(['documentPDF', 'base64string']);
        const errorContent = immPdfRevolving.get('documentError');

        const {
            productName,
            producto,
            standard,
            subproducto,
        } = precontractualMailProductInfo;

        const isPremiumOrDiamondCard = productName === PREMIUM_PACK_PRODUCT_NAME || (productName === DIAMOND_PACK_PRODUCT_NAME &&
            (producto !== '501' || subproducto !== '004' || (standard !== '0000001' && standard !== '0000002')) // This case is for diamond infinite
        );
        const poEditorKey = isPremiumOrDiamondCard ? 'documentCheckboxTextPremiumDiamond' : 'documentCheckboxText';
        const label = (
            <FormattedText
                value={this.getPoeKey(poEditorKey)}
                className="revolving-document__terms-and-conditions"
            />
        );
        const revolvingViewer = this.buildViewer(false, 'document');
        return (
            <div className="row revolving-document">
                {revolvingViewer}
                {pdfFile && !errorContent &&
                    <OKCheckbox
                        idName="revolving-document-checkbox"
                        labelId="revolving-document-checkbox-label"
                        label={label}
                        onChange={this.handleSetAgreeRevol}
                        value={agreeCheckboxRevol}
                    />
                }
            </div>
        )
    }

    buildLegalConsentLabel = () => (
            <div className='row provision-container'>
                <div className="col-xs-12">
                <FormattedText value="broker-provisionContractText1" />
                &nbsp;
                <OKLink
                    to={formatText('broker-stocksContractTACText4Link')}
                    target="_blank"
                    modifier="emphasize"
                >
                    <FormattedText value="broker-provisionContractText2" />
                </OKLink>
                <FormattedText value="broker-provisionContractText3" />
                </div>
            </div>
    );

    render() {
        const modalViewer = this.buildViewer(true, 'inne');
        const modalContentFooter = this.buildModalContentFooter();
        const { agreeCheckboxInne, primaryButtonText } = this.state;
        const { immFeatureFlags, immPdfRevolving, showRevolvingDocument, precontractualMailProductInfo } = this.props;
        const documentReaded = immPdfRevolving.get('documentReaded');
        const classLinkIne = classNames('revolving-inne__link-document', {
            'revolving-inne__link-document--checked': documentReaded
        });
        const isRevolvingDocumentVisible = immFeatureFlags.get('revolving_v2_ine') && validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
            ? !validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
            : showRevolvingDocument;

        return (
            <div className="revolving-container">
                <div className="row">
                    <div className="col-xs-12">
                        <h4 className="revolving-inne__title">{formatText(this.getPoeKey('inneDocumentReadedTitle'))}</h4>
                    </div>
                </div>
                <div className="row revolving-inne">
                    <div className="col-xs-9 col-md-10">
                        <p
                            className={classLinkIne}
                            onClick={this.handleIneLink}>
                            {formatText(this.getPoeKey('inneDocumentReadedLabel'))}
                        </p>
                    </div>
                    <div className="col-xs-3 col-md-2 revolving-inne__container-button">
                        {documentReaded ?
                            <span className="revolving-inne__readed-text">
                                <i className="icon-checkmark"></i>
                                {formatText(this.getPoeKey('inneDocumentReadedButton'))}
                            </span>
                            :
                            <OKButton
                                modifier="secondary"
                                onClick={this.handleOnShowModal}
                            >
                                {formatText(this.getPoeKey('inneDocumentNotReadedButton'))}
                            </OKButton>
                        }

                    </div>
                    <OKModal
                        isOpen={this.state.showModal}
                        onCloseCallback={this.handleOnShowModal}
                        contentFooter={modalContentFooter}
                        contentOverflow="hidden"
                        footerType="navigation"
                        content={modalViewer}
                        getSize={this.getSize}
                        noContentScroll
                        size="full-screen"
                        onPrimaryButtonClick={this.handleContinue}
                        onSecondaryButtonClick={this.handleOnShowModal}
                        primaryButtonText={primaryButtonText}
                        primaryButtonDisabled={!agreeCheckboxInne}
                        secondaryButtonText="Cancelar"
                        sizeToFixContentHeight={80}
                    />
                </div>
                {this.buildLegalConsentLabel()}
                {
                    documentReaded && isRevolvingDocumentVisible && this.buildRevolvingDocument()
                }

            </div>
        )
    }
}

CardLegalViewerModal.propTypes = {
    amount: PropTypes.any,
    agreeCheckboxRevol: PropTypes.bool,
    downloadRevolvingPDF: PropTypes.func,
    handleAgreementCheckboxChange: PropTypes.func,
    immPdfRevolving: PropTypes.object,
    immPdfRevolvingPersistent: PropTypes.object,
    isContractingProcess: PropTypes.bool,
    onPrintRevolvingDocument: PropTypes.func,
    precontractualMailProductInfo: PropTypes.object,
    sendPrecontractualDocumentMail: PropTypes.func,
    setDocumentInneReaded: PropTypes.func,
    setTermsAndCondsText: PropTypes.func,
    showRevolvingDocument: PropTypes.bool,
    requestRevolvingDocument: PropTypes.func,
    resetRevolvingProcess: PropTypes.func,
    immFeatureFlags: PropTypes.object.isRequired,
}

module.exports = connect(state => ({
    immPdfRevolving: state.revolvingDocumentsPdfs,
    immPdfRevolvingPersistent: state.revolvingPersistentData,
    immFeatureFlags: state.flagBasedFeatures,
}),
    {
        downloadRevolvingPDF: revolvingActions.downloadRevolvingPDF,
        onPrintRevolvingDocument: revolvingActions.onPrintRevolvingDocument,
        setDocumentInneReaded: revolvingActions.setDocumentInneReaded,
        requestRevolvingDocument: revolvingActions.requestRevolvingDocument,
        sendPrecontractualDocumentMail: revolvingActions.sendPrecontractualDocumentMail,
        setTermsAndCondsText: revolvingActions.setTermsAndCondsText,
        resetRevolvingProcess: revolvingActions.resetRevolvingProcess
    }
)(CardLegalViewerModal);
